import { IPromise } from 'angular';
import { StorageService } from './storage.service';
import { StoreService } from './store.service';

export class LogoService {
    static $inject: string[] = [
        '$q',
        'StorageService',
        'StoreService'
    ];

    constructor(
        private $q: ng.IQService,
        private storageService: StorageService,
        private storeService: StoreService
    ) {
    }

    getImagePreview(): IPromise<any> {
        let logoStoragePath = this.storeService.getUser().organizationData.logoStoragePath;
        if (!logoStoragePath) {
            return this.$q.reject();
        }

        return this.storageService.getBase64(logoStoragePath);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/services/logo.service.ts